export interface Token {
  address: string;
  symbol: string;
  name: string;
  decimals: number;
  logoURI?: string;
}

export interface PrepareRequest {
  receiver: string;
  slippage?: number;
  token_in: string;
  token_in_max_amount?: string;
  token_out: string;
  token_out_min_amount?: string;
  user: string;
}

export interface EIP712TypeEntry {
  name: string;
  type: string;
}

export interface EIP712Domain {
  name: string;
  version: string;
  chainId: string;
  verifyingContract: string;
}

export interface EIP712PermitMessage {
  owner: string;
  spender: string;
  value: string;
  nonce: string;
  deadline: string;
}

export interface EIP712SwapDataMessage {
  executionContract: string;
  functionSignature: string;
  executionCalldata: string;
  outputToken: string;
  receiver: string;
  inputAmount: string;
  minAmountOut: string;
}

export interface EIP712ExecuteSwapMessage {
  token: string;
  swapData: EIP712SwapDataMessage;
  feeAmount: string;
  nonce: string;
  deadline: string;
}

export interface EIP712TypedData {
  types: {
    Permit?: EIP712TypeEntry[];
    ExecuteSwap?: EIP712TypeEntry[];
    SwapData?: EIP712TypeEntry[];
    [key: string]: EIP712TypeEntry[] | undefined;
  };
  primaryType: string;
  domain: EIP712Domain;
  message: EIP712PermitMessage | EIP712ExecuteSwapMessage;
}

export interface FeeDataResponse {
  execution_contract: string;
  selector: string;
  execution_calldata: string;
  input_amount: string;
}

export interface PrepareMetaTxPayload {
  fee_data: FeeDataResponse;
  eip712: EIP712TypedData[];
  service_signature: string;
  slippage: number;
  relayer_fee_percent: number;
  fee_amount: string;
}

export interface PrepareResponse {
  status: string;
  payload: PrepareMetaTxPayload;
  protocol?: string;
}

export interface SubmitMetaTxRequest {
  fee_data: FeeDataResponse;
  eip712: EIP712TypedData[];
  service_signature: string;
  fee_amount: string;
  permit_signature: string;
  execute_swap_signature: string;
}

export interface SubmitMetaTxResponse {
  status: string;
  protocol?: string;
  payload?: { order_id: string };
  order_id?: string;
}

export interface SwapStatusResponse {
  status: string;
  order_id: string;
  swap_status: string;
  tx_hash?: string;
}

export const SWAP_STATUS_DISPLAY: Record<string, { emoji: string; label: string }> = {
  TRANSACTION_STATUS_PENDING: { emoji: '⏳', label: 'Pending' },
  TRANSACTION_STATUS_SIMULATION_FAILED: { emoji: '❌', label: 'Simulation Failed' },
  TRANSACTION_STATUS_CONFIRMED: { emoji: '✅', label: 'Confirmed' },
  TRANSACTION_STATUS_REVERTED: { emoji: '↩️', label: 'Reverted' },
};

export const TERMINAL_SWAP_STATUSES = [
  'TRANSACTION_STATUS_CONFIRMED',
  'TRANSACTION_STATUS_REVERTED',
  'TRANSACTION_STATUS_SIMULATION_FAILED',
];

export const EXPLORER_TX_URL =
  process.env.REACT_APP_EXPLORER_TX_URL || 'https://explorer.test.mezo.org/tx/';

export const ERC20_ABI = [
  'function balanceOf(address owner) view returns (uint256)',
] as const;
